<style scoped>

</style>

<template>
  <span>
    <slot slot-scope="scope"></slot>
    <mu-dialog 
      :title="title" 
      scrollable 
      max-width="100%" 
      width="480px" 
      :esc-press-close="false" 
      :overlay-close="false" 
      :open.sync="editing"
      >
      <mu-form :model="data" label-position="top" label-width="100">
        <mu-form-item prop="input" :label="$t('ChannelManage.name')">
          <mu-text-field v-model="data.name"></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="textarea" :label="$t('ChannelManage.alias')">
          <mu-text-field v-model="data.alias"></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="input" :label="$t('ChannelManage.public.display')">
          <mu-radio v-model="data.public" :value="false" :label="$t('ChannelManage.public.no')"></mu-radio>
          <mu-radio v-model="data.public" :value="true" :label="$t('ChannelManage.public.yes')"></mu-radio>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="primary" @click="onActionCancel">
        <mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}
      </mu-button>
      <mu-button slot="actions" flat color="primary" @click.prevent="onActionEdit" :disabled="isChannelNameEmpty">
        <mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}
      </mu-button>
    </mu-dialog>

    <mu-dialog :title="$t('button.edit') + $t('space') + $t('ChannelManage.thumbnail.display')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="thumbnail">
      <mu-checkbox v-model="data.thumbnail" :label="$t('ChannelManage.thumbnail.use')"></mu-checkbox>
      <div v-if="data.thumbnail">
          <br />
          <input type="file" id="file" ref="thumbnail" @change="onChangeFile" />
      </div>
      <mu-button slot="actions" flat color="primary" @click="onActionCancel">
        <mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}
      </mu-button>
      <mu-button slot="actions" flat color="primary" @click="onActionThumbnail">
        <mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}
      </mu-button>
    </mu-dialog>
  </span>
</template>

<script>

import langEn from './lang/en.json'
import langZh from './lang/zh.json'

export default {
  name: 'ManageChannel',
  props: {
    value: {
      type: Object,
      default() {
        return {
          name: "",
          alias: "",
          type: ""
        };
      }
    },
    editing: {
      type: Boolean,
      default: false
    },
    thumbnail: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      data: JSON.parse(JSON.stringify(this.value)),
      
      modelFile: null,
    }
  },
  computed: {
    // Flag
    isChannelNameEmpty() {
      return this.data.name === '';
    },
  },
  watch: {
    data: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true
    },
    value: {
      handler(newValue) {
        if(typeof this.data._id !== 'undefined' && this.data._id !== newValue._id) {
          this.data = JSON.parse(JSON.stringify(this.value))
        }
      },
      deep: true
    },
  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
  },
  methods: {
    onActionCancel() {
      this.$emit('cancel');
    },
    onActionEdit() {
      this.$emit('save', this.data);
    },
    onActionThumbnail() {
      let formData = new FormData();
      formData.append('_method', "PUT");
      if(this.data.thumbnail) {
        formData.append('file', this.modelFile);
      }
      this.$emit('thumbnail', formData);
    },
    onChangeFile() {
      if (this.$refs.thumbnail.files[0] != undefined) {
        this.modelFile = this.$refs.thumbnail.files[0];
      } else {
        this.modelFile = null;
      }
    },
  }
}
</script>
